import moment from "moment-timezone";
import i18n from 'i18next'
import PatientPresenter from './PatientPresenter';

export default class DocumentPresenter {
  constructor(documentData) {
    this.document = documentData;
  }

  getUUID() {
    return this.document.uuid;
  }

  getTitle() {
    if (!this.isReady()) {
      return i18n.t('patient_documents.generating');
    }
    return this.getDocType();
  }

  getDocType() {
    return i18n.t(`patient_documents.types.${this.document.doc_type}`);
  }

  getBody() {
    return this.document.user_body || this.document.gen_body || '';
  }

  getUserBody() {
    return this.document.user_body || '';
  }

  getProblem() {
    return this.document.problem || '';
  }

  getCompletedAt() {
    if (!this.document.completed_at) return null;

    const time = this.document.completed_at;
    return moment.utc(time).format('D MMMM');
  }

  isReady() {
    return Boolean(this.document.completed) && Boolean(this.document.gen_body);
  }

  isGenerating() {
    return !Boolean(this.document.completed);
  }

  getLink() {
    return `/documents/${this.getUUID()}`;
  }

  hasProblem() {
    return Boolean(this.document.problem);
  }

  getPatient() {
    return this.document?.patient ? new PatientPresenter(this.document.patient) : null;
  }
}